export default __webpack_public_path__ + "static/media/tube-2-en.90905b58.svg";